import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { APPLICATION_RESPONSES_ERROR, CREATE_APPLICATION_RESPONSE, CREATING_APPLICATION_RESPONSE, GETTING_APPLICATION_RESPONSES, GET_APPLICATION_RESPONSES } from "../types"

export const createApplicationResponse = (applicationId, applicationResponsePayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_APPLICATION_RESPONSE,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/applications/${applicationId}/responses`, applicationResponsePayload, { headers })
        
        dispatch({
            type: CREATE_APPLICATION_RESPONSE,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: APPLICATION_RESPONSES_ERROR,
            error
        })
    }
}

// export const updateApplication = (applicationId, applicationPayload) => async (dispatch) => {    
//     try{
//         const headers = authHeader()

//         dispatch({
//             type: UPDATING_APPLICATION,
//             payload: true
//         })
//         const response = await axios.patch(`${baseUrl}/applications/${applicationId}`, applicationPayload, { headers })
        
//         dispatch({
//             type: UPDATED_APPLICATION,
//             payload: response.data.data
//         })
        
//     }
//     catch(error){
//         dispatch({
//             type: APPLICATIONS_ERROR,
//             error
//         })
//     }
// }

// export const updateApplicationExam = (applicationId, applicationPayload) => async (dispatch) => {    
//     try{
//         const headers = authHeader()

//         dispatch({
//             type: UPDATING_APPLICATION,
//             payload: true
//         })

//         const response = await axios.patch(`${baseUrl}/applications/${applicationId}/update-exam`, applicationPayload, { headers })
        
//         dispatch({
//             type: UPDATED_APPLICATION,
//             payload: response.data.data
//         })
        
//     }
//     catch(error){
//         dispatch({
//             type: APPLICATIONS_ERROR,
//             error
//         })
//     }
// }

export const fetchApplicationResponses = (applicationId, filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/applications/${applicationId}/responses?expand=createdBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_APPLICATION_RESPONSES,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_APPLICATION_RESPONSES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: APPLICATION_RESPONSES_ERROR,
            error
        })
    }
}

export const clearCreatedApplicationResponse = () => async (dispatch) => { 
    dispatch({
        type: CREATE_APPLICATION_RESPONSE,
        payload: null
    })
}

// export const clearUpdatedApplication = () => async (dispatch) => { 
//     dispatch({
//         type: UPDATED_APPLICATION,
//         payload: null
//     })
// }